/** Where a template is built by hand in the advanced editor. */
export const NEW_TEMPLATE_PATH = '/parse-templates/new'

/** A saved template in the editor; an AI draft opens here too (spec D4/D12). */
export function templateEditorPath(templateId: number): string {
  return `/parse-templates/${templateId}`
}
